/**
 * 入力文字数カウンタ（data 属性駆動。user-admin 05_ui.md §1.2）
 *
 * マークアップ規約:
 *   <div class="lms-field">
 *     <textarea data-lms-counter-max="100"></textarea>
 *     <div class="lms-counter">0 / 100</div>
 *   </div>
 *
 * maxlength は付けない（上限超過をサーバー側検証で扱わせるため）。文字数超過時は
 * .lms-counter に is-over クラスを付与する。
 */

function findCounter(input: HTMLElement): HTMLElement | null {
  const next = input.nextElementSibling;
  if (next instanceof HTMLElement && next.classList.contains("lms-counter")) {
    return next;
  }
  const field = input.closest(".lms-field");
  return field ? field.querySelector<HTMLElement>(".lms-counter") : null;
}

export function initCounter(scope: ParentNode = document): void {
  scope
    .querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("[data-lms-counter-max]")
    .forEach((input) => {
      if (input.dataset["lmsCounterReady"] === "1") return;
      input.dataset["lmsCounterReady"] = "1";

      const max = Number(input.dataset["lmsCounterMax"]);
      const counter = findCounter(input);
      if (!counter || Number.isNaN(max)) return;

      const update = (): void => {
        const length = input.value.length;
        counter.textContent = `${length} / ${max}`;
        counter.classList.toggle("is-over", length > max);
      };

      update();
      input.addEventListener("input", update);
    });
}
